export enum StoreMarketEnum {
  FR = 'France',
  IT = 'Italy',
  ES = 'Spain',
  PT = 'Portugal',
  BE = 'Belgium',
  AT = 'Austria',
  DE = 'Germany',
  NL = 'Netherlands',
  UK = 'United Kingdom',
  PL = 'Poland',
  CZ = 'Czech Republic',
  BG = 'Bulgaria',
  SK = 'Slovakia',
  HU = 'Hungary'
}
